import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Terms = () => {
  const { t } = useTranslation();

  // Функция для рендера контента с поддержкой списков и ссылок
  const renderContent = (content) => {
    return content.map((item, index) => {
      // Если это строка (простой параграф)
      if (typeof item === 'string') {
        // Проверяем, является ли строка элементом списка (начинается с "- ")
        if (item.startsWith('- ')) {
          return (
            <ul key={index} className="list-disc pl-6 mb-3">
              <li>{item.replace('- ', '')}</li>
            </ul>
          );
        }
        // Проверяем, содержит ли строка URL
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        if (urlRegex.test(item)) {
          const parts = item.split(urlRegex);
          return (
            <p key={index} className="mb-3">
              {parts.map((part, i) => 
                urlRegex.test(part) ? (
                  <a 
                    key={i} 
                    href={part} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-blue-600 underline"
                  >
                    {part}
                  </a>
                ) : (
                  part
                )
              )}
            </p>
          );
        }
        // Обычный параграф
        return <p key={index} className="mb-3">{item}</p>;
      }
      
      // Если это объект с ссылкой (из старой структуры)
      if (item.link) {
        return (
          <p key={index} className={item.className || 'mb-3'}>
            {item.text}
            {item.link.url.startsWith('http') || item.link.url.startsWith('mailto:') ? (
              <a
                href={item.link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline ml-1"
              >
                {item.link.text}
              </a>
            ) : (
              <Link to={item.link.url} className="text-blue-600 underline ml-1">
                {item.link.text}
              </Link>
            )}
          </p>
        );
      }

      // Если это список (из старой структуры)
      if (item.list) {
        return (
          <ul key={index} className="list-disc pl-6 mb-3">
            {item.list.map((listItem, listIndex) => (
              <li key={listIndex}>{listItem}</li>
            ))}
          </ul>
        );
      }

      return null;
    });
  };

  const sections = t('terms.sections', { returnObjects: true });
  const adminDetails = t('terms.administrator_details', { returnObjects: true });

  return (
    <div className="container mx-auto max-w-4xl py-8 px-4 sm:px-6 lg:px-8">
      <div className="bg-white p-6 rounded-lg">
        <h1 className="text-3xl font-bold text-center mb-6">
          {t('terms.title')}
        </h1>
        <h2 className="text-xl font-semibold text-center mb-8">
          {t('terms.academy_name')}
        </h2>

        <p className="mb-8 text-gray-700">{t('terms.intro_text')}</p>

        <div className="space-y-8">
          {sections.map((section, index) => (
            <section key={index} className="mb-8">
              <h3 className="text-xl font-semibold mb-4 text-blue-800">
                {section.title}
              </h3>
              <div className="text-gray-700">
                {renderContent(section.content)}
              </div>
            </section>
          ))}

          <section className="mt-10 p-5 bg-gray-50 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 text-blue-800">
              {adminDetails.title}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-gray-700">
              {adminDetails.content.map((line, index) => (
                <p key={index}>{line}</p>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};